import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {CartLineRepository} from "./cart-line-repository.service";
import {CartQuantityNotifier} from "@app/core/cart/domain/cart-quantity-notifier";
import {switchMap} from "rxjs/operators";

/**
 * Use case for getting the quantity of a cart line.
 */
@Injectable({
    providedIn: "root",
})
export class GetCartLineQuantityUseCase {
    constructor(
        private cartLineRepository: CartLineRepository,
        private cartQuantityNotifier: CartQuantityNotifier
    ) { }

    /**
     * Gets the quantity of a cart line.
     *
     * @param productCode - Product code of the cart line.
     * @param promotionCode - Promotion code of the cart line.
     *                        If the cart line is not a promotion, this parameter is ignored.
     * @returns An Observable that emits the quantity of the cart line each time the cart is updated.
     */
    execute(productCode: string, promotionCode: string): Observable<number> {
        return this.cartQuantityNotifier.cartQuantity$.pipe(
            switchMap(() => this.cartLineRepository.getQuantity(productCode, promotionCode))
        );
    }
}
